<template>
  <grid-container class="text-center">
    <p>Your Time is up!</p>

    <p>You have answered {{answeredQuestions}} out of {{totalQuestions}} questions.</p>

    <p>You can close this window. Your results will be automatically shared with the company.</p>

    <p>Thank you for your effort!</p>

  </grid-container>
</template>

<script>
export default {
  name: 'TimeUp',
  computed: {
    siteUrl() {
      return process.env.VUE_APP_DASHBOARD_SJT_SCREEN
    },
    softSkillsInvited() {
      return this.$store.getters.softSkillsInvited
    },
    softSkills() {
      return this.$store.getters.softSkills
    },
    invited() {
      const items = []
      this.softSkills.forEach(el => {
        const element = this.softSkillsInvited.find(elem => {
          return elem.name === el.name
        })
        if (element) {
          items.push(el)
        }
      })
      return items
    },
    totalQuestions() {
      let total = 0
      this.invited.forEach(inv => {
        total += inv.questions.length
      })

      return total
    },
    answeredQuestions() {
      let total = 0
      this.invited.forEach(inv => {
        const answered = inv.questions.filter(q => {
          return q.answered
        })

        total += answered.length
      })

      return total
    }
  },
  methods: {
    viewResults() {
      window.location = this.siteUrl
    }
  },
  created() {
    // setTimeout(() => {
    //   this.viewResults()
    // }, 5000)
  }
}
</script>

<style scoped>
  .container p {
    margin: 24px 0;
  }
</style>
